import styled from 'styled-components';
import { device } from '../../utils/styled-component-mixins';

const WidgetSpacingWrapperStyled = styled.div`
  z-index: 10;

  ${(props) =>
    (props.marginBottomDesktop || props.marginTopDesktop) && 'height: 100%; position: relative;'}

  ${(props) =>
    props.marginBottomMobile
      ? `margin-bottom: ${props.marginBottomMobile}rem;`
      : 'margin-bottom: 0;'}
  ${(props) =>
    props.marginTopMobile ? `margin-top: ${props.marginTopMobile}rem;` : 'margin-top: 0;'}

  @media ${device.desktop} {
    ${(props) =>
      props.marginBottomDesktop
        ? `margin-bottom: ${props.marginBottomDesktop}rem;`
        : 'margin-bottom: 0;'}
    ${(props) =>
      props.marginTopDesktop ? `margin-top: ${props.marginTopDesktop}rem;` : 'margin-top: 0;'}
  }
`;

export const withWidgetSpacingWrapper =
  (Component) =>
  ({ className = '', marginBottom, marginTop, ...passThroughProps }) =>
    (
      <WidgetSpacingWrapperStyled
        className={className}
        marginBottomDesktop={marginBottom}
        marginBottomMobile={marginBottom / 2}
        marginTopDesktop={marginTop}
        marginTopMobile={marginTop / 2}
      >
        <Component {...passThroughProps} />
      </WidgetSpacingWrapperStyled>
    );

export default WidgetSpacingWrapperStyled;
